var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00723 1.50049C3.36056 1.50049 2.80796 1.92288 2.59778 2.50206H13.4283C13.2179 1.92288 12.6645 1.50049 12.0179 1.50049H4.00723ZM2.00408 3.50462C1.18043 3.50462 0.498779 4.18529 0.498779 5.00893V13.0196C0.498779 13.8432 1.18043 14.5249 2.00408 14.5249H14.022C14.8456 14.5249 15.5224 13.8432 15.5224 13.0196V5.00893C15.5224 4.18529 14.8456 3.50462 14.022 3.50462H2.00408ZM8.00374 5.50092C8.28767 5.49558 8.51867 5.72658 8.51333 6.01051V10.81L9.66358 9.66274C9.70848 9.61032 9.76373 9.56775 9.82587 9.53769C9.888 9.50764 9.95568 9.49075 10.0246 9.4881C10.0936 9.48544 10.1624 9.49706 10.2267 9.52224C10.2909 9.54742 10.3493 9.58561 10.3981 9.63441C10.4469 9.68322 10.4851 9.74159 10.5103 9.80585C10.5354 9.87011 10.5471 9.93889 10.5444 10.0079C10.5417 10.0768 10.5249 10.1445 10.4948 10.2066C10.4648 10.2688 10.4222 10.324 10.3698 10.3689L8.36564 12.3731C8.2718 12.4663 8.14486 12.5187 8.01255 12.5187C7.88023 12.5187 7.75329 12.4663 7.65945 12.3731L5.6563 10.3689C5.58779 10.3024 5.53971 10.2177 5.51772 10.1248C5.49574 10.0319 5.50077 9.93466 5.53223 9.84452C5.56368 9.75437 5.62024 9.6751 5.69525 9.61603C5.77026 9.55696 5.86059 9.52057 5.9556 9.51113C6.03045 9.50425 6.10589 9.5143 6.17633 9.54054C6.24677 9.56679 6.31039 9.60855 6.36249 9.66274L7.51176 10.813V6.01051C7.50657 5.73383 7.72706 5.5066 8.00374 5.50092Z",
    fill: "url(#paint0_linear_399_268)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_268",
    x1: 8.01059,
    y1: 1.50049,
    x2: 8.01059,
    y2: 14.5249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedOnboarding);
export default __webpack_public_path__ + "static/media/selectedOnboarding.8da8af1cc9f1fcf70afe463ed29547ca.svg";
export { ForwardRef as ReactComponent };